export default {
  namespaced: true,
  bulk_edit: {
    title: "Bulk changes",
    modal_title: "Bulk edit",
    activate_mode: "Enable multi-selection",
    multi_select: "Multiple selection",
    select_all: "Select all",
    exit: "Exit selection",
    edit_selected: "Edit ({count})",
    info_message: "{count} selected records will be modified.",
    only_filled_fields: "Only fields with a selected value will be updated. Empty fields will not be modified.",
    select_placeholder: "No changes",
    select_dependency_placeholder: "Select {field} first",
    apply_changes: "Apply changes ({count})",
    success: "Bulk update successful",
    confirm_title: "Confirm bulk changes",
    confirm_body: "Are you sure you want to apply the changes to {count} records?",
    batch_progress_title: "Bulk update in progress",
    batch_progress_text: "Processing {count} records...",
    batch_cancelled: "The bulk update was cancelled",
    batch_status_error: "Could not check the bulk update status",
    batch_in_progress: "A bulk update is already in progress, wait for it to finish",
    enable_field: "modify this field",
    cameras_selected: "{count} selected devices",
    assign_selected: "Devices to assign",
    assign_count: "{count} to assign",
    device_id: "Camera Proxy ID: {id}",
    assign_all: "Assign all",
    assign_all_warning: "ALL devices matching the filters will be assigned to the selected users.",
    unassign_all: "Unassign all",
    unassign_all_warning: "ALL devices matching the filters will be removed from the selected users.",
    replace_lists_hint: "The selected lists (tenants, alarm types, modules) will completely replace the ones assigned to each user.",
    additional_info_hint: "This list will completely replace the additional information of each selected record.",
    emergency_contact_hint: "This list will completely replace the emergency contacts of each selected record.",
  },
};
